import {CharacterStateBase} from './_stateLibrary';
import {ICharacterState} from '../../interfaces/ICharacterState';
import {Character} from '../Character';
import {Idle} from './Idle';
import { CharacterAnimation } from '../../enums/CharacterAnimation';
import * as THREE from "three";
import { BloodEffect } from "../particles/BloodEffect";
import { BodyPart } from "../../enums/BodyPart";
import { Hurt } from "./Hurt";
import { EntityType } from "../../enums/EntityType";

export class Punch extends CharacterStateBase implements ICharacterState {
    private rayCaster: THREE.Raycaster;
    private blood: BloodEffect;
    private hasHit: boolean;

    constructor(character: Character) {
        super(character);
        this.rayCaster = new THREE.Raycaster();

        this.character.simulation.velocitySimulator.damping = 0.6;
        this.character.simulation.velocitySimulator.mass = 10;
        this.character.isPunching = true;
        this.character.simulation.setArcadeVelocityTarget(0);
        this.playAnimation(CharacterAnimation.Punch, 0.1, true);
    }

    public update(timeStep: number): void {
        super.update(timeStep);
        this.fallInAir();
        this.onDie();
        this.handleImpact();
        // If this character stop punching, go back to idle state
           if (this.animationEnded(timeStep)) {
               this.character.isPunching = false;
               this.character.setState(new Idle(this.character))
           }
    }

    private handleImpact(): void {
        if (this.hasHit) return; // Prevent multiple hits per punch

        // Get the position of the hand (assumed to be named "RightHand" or similar)
        const hand = this.character.getObjectByName(BodyPart.RightHand) || this.character.getObjectByName(BodyPart.LeftHand);
        if (!hand) return;

        const handWorldPos = new THREE.Vector3();
        hand.getWorldPosition(handWorldPos);

        // Loop through potential targets
        for (const punchedEntity of this.character.world.graphicsWorld.children) {
            if (punchedEntity !== this.character && punchedEntity) {

                // Check if the entity is a Character before casting
                if ((punchedEntity as any).entityType === EntityType.Character) {
                    const character = punchedEntity as Character;
                    const npcPos = new THREE.Vector3();
                    character.getWorldPosition(npcPos);

                    const distance = handWorldPos.distanceTo(npcPos);

                    // If within punching range
                    if (distance < 1.5 && !character.isDead) { // 1.5 units range for a punch
                        this.blood = new BloodEffect(this.character.world);
                        this.blood.spawn(character, npcPos);

                        character.setState(new Hurt(character));
                        character.takeDamage(50);
                        this.character.world.crimeDetectionService?.reportCrime({ position: npcPos, perpetrator: this.character });
                        this.hasHit = true; // Only hit once per punch
                        break;
                    }
                }
            }
        }
    }
    public onInputChange(): void {
        super.onInputChange();
    }
}
